import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="add-fields"
export default class extends Controller {
  static targets = [ "link" ]

  add(event) {
    event.preventDefault()
    // Save a unique timestamp to ensure the key of the associated array is unique.
    let time = new Date().getTime()
    // Save the data id attribute into a variable. This corresponds to `new_object.object_id`.
    let linkId = this.linkTarget.dataset.id
    // Create a new regular expression needed to find any instance of the `new_object.object_id` used in the fields data attribute if there's a value in `linkId`.
    let regexp = linkId ? new RegExp(linkId, 'g') : null
    // Replace all instances of the `new_object.object_id` with `time`, and save markup into a variable if there's a value in `regexp`.
    let newFields = regexp ? this.linkTarget.dataset.fields.replace(regexp, time) : null
    // Add the new markup to the form if there are fields to add.
    newFields ? this.linkTarget.insertAdjacentHTML('beforebegin', newFields) : null
  }
}
